import axios from 'axios'
import { useState } from 'react'
import { getCookie } from '../../GlobalComponents/GlobalFunctions'
import { getBaseURL } from '../../GlobalComponents/URLs'

export const useApiUpload = () => {
    const [uploading, setUploading] = useState(false)
    const [uploadDone, setUploadDone] = useState(false)
    const [progress, setProgress] = useState(0)
    const [errorData, setErrorData] = useState([] as importData[])

    const onUploadClick = async (fileData: importData[]) => {
        setUploading(true)
        const uploadServiceUrl = `${getBaseURL()}webapics/api/v1/LOBUpload`
        const totalRequests = fileData.filter((rowData) => rowData.ErrorCount === 0).length
        let completedRequests = 0
        const company=getCookie('CoRoot')
        for (const rowData of fileData) {
            if (rowData.ErrorCount === 0) {
                try {
                    const response = await axios.post(
                        uploadServiceUrl,
                        {
                            VendorId: rowData.VendorID.Value,
                            LOBCode: rowData.LOBCode.Value,
                        },
                        {
                            headers: {
                                Company: company,
                            },
                        }
                    )
                    if (response && response.status >= 200 && response.status < 300) {
                    } else {
                        errorData.push({
                            ...rowData,
                            ErrorCount: 1,
                            VendorID: { ...rowData.VendorID, Error: 'Server Error' },
                        })
                        setErrorData(errorData)
                    }
                    completedRequests++
                    setProgress(Math.round((completedRequests / totalRequests) * 100))
                } catch (error: any) {
                    errorData.push({
                        ...rowData,
                        ErrorCount: 1,
                        VendorID: { ...rowData.VendorID, Error: 'Server Error' },
                    })
                    setErrorData(errorData)
                    completedRequests++
                    setProgress(Math.round((completedRequests / totalRequests) * 100))
                }
            }
        }
        setUploading(false)
        setUploadDone(true)
    }
    return { uploading, uploadDone, onUploadClick, progress, errorData }
}
